// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ShopQuests_container__2xjDb {
  padding-top: 100px;
  max-width: 85%;
  margin: 0 auto;
}
.ShopQuests_container__2xjDb .ShopQuests_wrapper__M90n9 {
  font-size: 20px;
  font-weight: 400;
  font-style: normal;
  color: #e0e0e0;
  position: relative;
  width: 100%;
  z-index: 2;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.ShopQuests_container__2xjDb .ShopQuests_wrapper__M90n9 .ShopQuests_title__kefqk {
  font-size: 48px;
  font-weight: 700;
  font-family: "Open Sans Bold";
  color: #faf9f8;
  width: 603px;
}
.ShopQuests_container__2xjDb .ShopQuests_wrapper__M90n9 .ShopQuests_title__kefqk .ShopQuests_yellow__gGzp5 {
  color: #f2f740;
}
.ShopQuests_container__2xjDb .ShopQuests_wrapper__M90n9 .ShopQuests_info__znL\\+c {
  font-family: "Open Sans Regular";
  font-size: 18px;
  letter-spacing: -0.02em;
  color: #c2bdb2;
  width: 672px;
}
.ShopQuests_container__2xjDb .ShopQuests_wrapper__M90n9 .ShopQuests_info__znL\\+c .ShopQuests_txt__AmSs6 {
  margin-top: 4px;
}
.ShopQuests_container__2xjDb .ShopQuests_wrapper__M90n9 .ShopQuests_button_group__m4F6h {
  display: flex;
  flex-direction: row;
  gap: 16px;
}
.ShopQuests_container__2xjDb .ShopQuests_wrapper__M90n9 .ShopQuests_button_group__m4F6h .ShopQuests_btn__2MdZK {
  font-family: "Open Sans SemiBold";
  font-size: 16px;
  border-radius: 12px;
  background: #f2f740;
  text-transform: capitalize;
  color: #292621;
  cursor: pointer;
  min-width: 80px;
  height: 42px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  padding: 8px;
}
.ShopQuests_container__2xjDb .ShopQuests_wrapper__M90n9 .ShopQuests_button_group__m4F6h .ShopQuests_btn__2MdZK:hover {
  background-color: #f5f966;
}
.ShopQuests_container__2xjDb .ShopQuests_wrapper__M90n9 .ShopQuests_button_group__m4F6h .ShopQuests_btn__2MdZK:active {
  background-color: #e6eb3d;
}
.ShopQuests_container__2xjDb .ShopQuests_wrapper__M90n9 .ShopQuests_button_group__m4F6h .ShopQuests_btn_back__EBg55 {
  font-family: "Open Sans SemiBold";
  font-size: 16px;
  border-radius: 12px;
  background: #3e3c37;
  text-transform: capitalize;
  color: #fff;
  cursor: pointer;
  width: 64px;
  height: 42px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}
.ShopQuests_container__2xjDb .ShopQuests_wrapper__M90n9 .ShopQuests_button_group__m4F6h .ShopQuests_btn_back__EBg55:hover {
  background-color: #51504b;
}
.ShopQuests_container__2xjDb .ShopQuests_wrapper__M90n9 .ShopQuests_pic__Lx5YG {
  max-width: 40%;
  height: auto;
  object-fit: contain;
  flex-shrink: 0;
}

@media (max-width: 850px) {
  .ShopQuests_container__2xjDb {
    padding-top: 30px;
  }
  .ShopQuests_container__2xjDb .ShopQuests_wrapper__M90n9 {
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
  }
  .ShopQuests_container__2xjDb .ShopQuests_wrapper__M90n9 .ShopQuests_back__nB5mF {
    margin-bottom: 24px;
  }
  .ShopQuests_container__2xjDb .ShopQuests_wrapper__M90n9 .ShopQuests_title__kefqk {
    font-size: 24px;
    width: 100%;
  }
  .ShopQuests_container__2xjDb .ShopQuests_wrapper__M90n9 .ShopQuests_info__znL\\+c {
    font-size: 16px;
    width: 100%;
  }
  .ShopQuests_container__2xjDb .ShopQuests_wrapper__M90n9 .ShopQuests_button_group__m4F6h .ShopQuests_btn__2MdZK {
    width: 100%;
    min-width: 84px;
  }
  .ShopQuests_container__2xjDb .ShopQuests_wrapper__M90n9 .ShopQuests_button_group__m4F6h .ShopQuests_btn__2MdZK button {
    width: 100%;
    justify-content: center;
  }
  .ShopQuests_container__2xjDb .ShopQuests_wrapper__M90n9 .ShopQuests_button_group__m4F6h .ShopQuests_btn_back__EBg55 {
    width: 100%;
    min-width: 84px;
  }
  .ShopQuests_container__2xjDb .ShopQuests_wrapper__M90n9 .ShopQuests_button_group__m4F6h .ShopQuests_btn_back__EBg55 button {
    width: 100%;
    justify-content: center;
  }
  .ShopQuests_container__2xjDb .ShopQuests_wrapper__M90n9 .ShopQuests_pic__Lx5YG {
    align-self: center;
    max-width: 100%;
    width: auto;
    height: auto;
    object-fit: contain;
    margin-top: 40px;
  }
  .ShopQuests_container__2xjDb .ShopQuests_reverse_direction__MtwhJ {
    flex-direction: column-reverse;
  }
}
.ShopQuests_rockets_subtitle__GsVvd {
  font-weight: 700;
  color: #faf9f8;
  margin-top: 4px;
}

.ShopQuests_rockets_txt__frVmH {
  color: #c2bdb2;
  margin-top: 4px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Welcome/ShopQuests/ShopQuests.module.scss","webpack://./src/assets/styles/_fonts.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,cAAA;EACA,cAAA;AADF;AAGE;ECoCA,eAAA;EACA,gBAAA;EACA,kBAAA;EDnCE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;AAAJ;AACI;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,cAAA;EACA,YAAA;AACN;AAAM;EACE,cAAA;AAER;AAEI;EACE,gCAAA;EACA,eAAA;EACA,uBAAA;EACA,cAAA;EACA,YAAA;AAAN;AAEM;EACE,eAAA;AAAR;AAGI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AADN;AAEM;EACE,iCAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,0BAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;AAAR;AAEQ;EACE,yBAAA;AAAV;AAGQ;EACE,yBAAA;AADV;AAIM;EACE,iCAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,0BAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAFR;AAIQ;EACE,yBAAA;AAFV;AAOI;EACE,cAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;AALN;;AAUA;EACE;IACE,iBAAA;EAPF;EASE;IACE,WAAA;IACA,sBAAA;IACA,uBAAA;EAPJ;EASI;IACE,mBAAA;EAPN;EAUI;IACE,eAAA;IACA,WAAA;EARN;EAWI;IACE,eAAA;IACA,WAAA;EATN;EAYM;IACE,WAAA;IACA,eAAA;EAVR;EAYQ;IACE,WAAA;IACA,uBAAA;EAVV;EAaM;IACE,WAAA;IACA,eAAA;EAXR;EAYQ;IACE,WAAA;IACA,uBAAA;EAVV;EAcI;IACE,kBAAA;IACA,eAAA;IACA,WAAA;IACA,YAAA;IACA,mBAAA;IACA,gBAAA;EAZN;EAgBE;IACE,8BAAA;EAdJ;AACF;AAkBA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AAhBF;;AAmBA;EACE,cAAA;EACA,eAAA;AAhBF","sourcesContent":["@use 'assets/styles/global.scss' as *;\n\n.container {\n  padding-top: 100px;\n  max-width: 85%;\n  margin: 0 auto;\n\n  .wrapper {\n    @include subtitle5;\n\n    color: #e0e0e0;\n    position: relative;\n    width: 100%;\n    z-index: 2;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    .title {\n      font-size: 48px;\n      font-weight: 700;\n      font-family: \"Open Sans Bold\";\n      color: #faf9f8;\n      width: 603px;\n      .yellow {\n        color: #f2f740;\n      }\n    }\n\n    .info {\n      font-family: \"Open Sans Regular\";\n      font-size: 18px;\n      letter-spacing: -0.02em;\n      color: #c2bdb2;\n      width: 672px;\n\n      .txt {\n        margin-top: 4px;\n      }\n    }\n    .button_group {\n      display: flex;\n      flex-direction: row;\n      gap: 16px;\n      .btn {\n        font-family: \"Open Sans SemiBold\";\n        font-size: 16px;\n        border-radius: 12px;\n        background: #f2f740;\n        text-transform: capitalize;\n        color: #292621;\n        cursor: pointer;\n        min-width: 80px;\n        height: 42px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        margin-top: 20px;\n        padding: 8px;\n\n        &:hover {\n          background-color: #f5f966;\n        }\n\n        &:active {\n          background-color: #e6eb3d;\n        }\n      }\n      .btn_back {\n        font-family: \"Open Sans SemiBold\";\n        font-size: 16px;\n        border-radius: 12px;\n        background: #3e3c37;\n        text-transform: capitalize;\n        color: #fff;\n        cursor: pointer;\n        width: 64px;\n        height: 42px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        margin-top: 20px;\n\n        &:hover {\n          background-color: #51504b;\n        }\n      }\n    }\n\n    .pic {\n      max-width: 40%;\n      height: auto;\n      object-fit: contain;\n      flex-shrink: 0;\n    }\n  }\n}\n\n@media (max-width: 850px) {\n  .container {\n    padding-top: 30px;\n\n    .wrapper {\n      width: 100%;\n      flex-direction: column;\n      align-items: flex-start;\n\n      .back {\n        margin-bottom: 24px;\n      }\n\n      .title {\n        font-size: 24px;\n        width: 100%;\n      }\n\n      .info {\n        font-size: 16px;\n        width: 100%;\n      }\n      .button_group {\n        .btn {\n          width: 100%;\n          min-width: 84px;\n\n          button {\n            width: 100%;\n            justify-content: center;\n          }\n        }\n        .btn_back {\n          width: 100%;\n          min-width: 84px;\n          button {\n            width: 100%;\n            justify-content: center;\n          }\n        }\n      }\n      .pic {\n        align-self: center;\n        max-width: 100%;\n        width: auto;\n        height: auto;\n        object-fit: contain;\n        margin-top: 40px;\n      }\n    }\n\n    .reverse_direction {\n      flex-direction: column-reverse;\n    }\n  }\n}\n\n.rockets_subtitle {\n  font-weight: 700;\n  color: #faf9f8;\n  margin-top: 4px;\n}\n\n.rockets_txt {\n  color: #c2bdb2;\n  margin-top: 4px;\n}","@mixin h1 {\n  font-size: 64px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h2 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h3 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1b {\n  font-size: 24px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle2m {\n  font-size: 24px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle3b {\n  font-size: 20px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle4m {\n  font-size: 20px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle5 {\n  font-size: 20px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin subtitle6m {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle7m {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonlarge {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonmedium {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonsmall {\n  font-size: 13px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin helper {\n  font-size: 12px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin tableinput {\n  font-size: 13px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n// New fonts\n\n@mixin header1 {\n  font-size: 56px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin header3 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin header4 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin header5 {\n  font-size: 28px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1 {\n  font-size: 24px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin subtitle2 {\n  font-size: 20px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin subtitle3 {\n  font-size: 16px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin subtitle4 {\n  font-size: 14px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonLarge {\n  font-size: 16px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin buttonMedium {\n  font-size: 14px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin buttonSmall {\n  font-size: 13px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 12px;\n  font-weight: 600;\n  font-style: normal;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ShopQuests_container__2xjDb`,
	"wrapper": `ShopQuests_wrapper__M90n9`,
	"title": `ShopQuests_title__kefqk`,
	"yellow": `ShopQuests_yellow__gGzp5`,
	"info": `ShopQuests_info__znL+c`,
	"txt": `ShopQuests_txt__AmSs6`,
	"button_group": `ShopQuests_button_group__m4F6h`,
	"btn": `ShopQuests_btn__2MdZK`,
	"btn_back": `ShopQuests_btn_back__EBg55`,
	"pic": `ShopQuests_pic__Lx5YG`,
	"back": `ShopQuests_back__nB5mF`,
	"reverse_direction": `ShopQuests_reverse_direction__MtwhJ`,
	"rockets_subtitle": `ShopQuests_rockets_subtitle__GsVvd`,
	"rockets_txt": `ShopQuests_rockets_txt__frVmH`
};
export default ___CSS_LOADER_EXPORT___;
